<style lang="scss" scoped>
.form-control {
  height: 40px;
}
</style>

<template>
  <div>
    <label class="form-label">{{ label || "Resultate" }}</label>
    <input
      class="form-control"
      type="text"
      :min="0"
      @input="emitFilter"
      :value="value"
      @keyup.enter="apply"
    />
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: null,
    label: null,
    id: null,
    attributes: null,
    name: {
      required: false,
      default: 'whereLike'
    }
  },
  computed: {
  },
  methods: {
    apply(event) {
      this.emitFilter(event);
    },
    emitFilter(event) {
      if (event.target.value) {
        this.$emit('filter-change', {
          id: this.id,
          name: this.name,
          attributes: this.attributes,
          value: event.target.value
        });
      } else {
        this.$emit('filter-change', {name: this.name, id: this.id});
      }
    }
  }
};
</script>
